import React, { useEffect, useRef, useState } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import api from "../services/api";

// Reuse your existing pages where possible:
import BusinessUserNav from "./BusinessUserNav";
import BusinessPage from "./BusinessPage";
import EmployeesPage from "./EmployeesPage";
import ViewPayrollPage from "./ViewPayroll";
import CheckWriter from "./CheckWriter";
//import AccountingPage from "./AccountingPage";
import BusinessUserProfilePage from "./BusinessUserProfilePage";
import MobileBusinessUserMenu from "./MobileBusinessUserMenu"; // reuse same mobile menu + styles
import BusinessCashInPage from "./BusinessCashInPage";
import StaffPayrollInputsPage from "./StaffPayrollInputsPage";

// NOTE: Using the SAME classnames & layout as your owner Dashboard.jsx
const BusinessDashboard = () => {
  const [businesses, setBusinesses] = useState([]);
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const hamburgerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Fetch businesses linked to the authenticated business user
  const fetchBusinesses = async () => {
    try {
      const { data } = await api.get("/bu/businesses");
      setBusinesses(data || []);
      if (data && data.length > 0) setSelectedBusiness(data[0]);
    } catch (e) {
      alert("Failed to fetch businesses for business user.");
    }
  };

  useEffect(() => {
    fetchBusinesses();
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Sync selected business with URL if present
  useEffect(() => {
    const match = location.pathname.match(/\/bus-dashboard\/business\/(\d+)/);
    if (match && businesses.length) {
      const id = Number(match[1]);
      const found = businesses.find((b) => b.id === id);
      if (found && (!selectedBusiness || selectedBusiness.id !== found.id)) {
        setSelectedBusiness(found);
      }
    }
  }, [location.pathname, businesses, selectedBusiness]);

  const handleLogout = async () => {
    try {
      await api.post("/business-logout");
      localStorage.removeItem("accessToken");
      sessionStorage.removeItem("accessToken");
      delete api.defaults.headers.common["Authorization"];
      navigate("/home");
      window.location.reload();
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  const handleBusinessChange = (e) => {
  const id = Number(e.target.value);
  const found = businesses.find((b) => b.id === id);
  setSelectedBusiness(found || null);
  if (!found) return;

  const { pathname, search, hash } = location;

  // Replace the current business id in-place, keep the rest of the path (e.g., /payroll-entry)
  const newPath = pathname.replace(
    /(\/bus-dashboard\/business\/)\d+/,
    `$1${id}`
  );

  if (newPath !== pathname) {
    // Stay on the same screen, just with the new business id
    navigate(newPath + search + hash);
  } else {
    // If there's no business id in the current path (e.g., profile),
    // send them to Payroll for the newly selected business.
    navigate(`/bus-dashboard/business/${id}/payroll-entry`);
  }
};


  return (
    <div className="dashboard-page">
      {/* Header — same layout & classes as owner Dashboard */}
      <header className="dashboard-header">
        {isMobile && (
          <img
            src="/logo512.png"
            alt="Payweek Logo"
            className="dashboard-logo"
          />
        )}

        <div className="business-selector">
          <select
            className="business-select"
            onChange={handleBusinessChange}
            value={selectedBusiness?.id ?? "default"}
          >
            <option value="default" disabled>
              Select a Business
            </option>
            {businesses.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </select>
        </div>

        <button
          ref={hamburgerRef}
          className="hamburger-menu"
          onClick={() => setIsMobileMenuOpen((s) => !s)}
        >
          ☰
        </button>

        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      </header>

      {/* Mobile slide-out menu (same component & behavior) */}
      {isMobile && isMobileMenuOpen && (
  <MobileBusinessUserMenu
    selectedBusiness={selectedBusiness}
    onLogout={handleLogout}
    onClose={() => setIsMobileMenuOpen(false)}
    hamburgerRef={hamburgerRef}
  />
)}


      {/* Left nav — reuse the same nav-panel styling via BusinessUserNav */}
      {!isMobile && <BusinessUserNav selectedBusiness={selectedBusiness} />}

      {/* Body — same classnames as owner Dashboard */}
      <div className="dashboard-body">
        <main className="dashboard-content">
          <Routes>
            {/* default redirect (inside /bu/*) */}
            <Route path="/" element={<Navigate to="business/user/profile" />} />

            {/* Profile/Settings (business user) */}
            <Route path="business/user/profile" element={<BusinessUserProfilePage />} />

            {/* Business-scoped routes */}
            <Route path="business/:id" element={<BusinessPage selectedBusiness={selectedBusiness} />} />
            <Route path="business/:id/employees" element={<EmployeesPage selectedBusiness={selectedBusiness} />} />
            <Route path="business/:id/viewpayroll" element={<ViewPayrollPage selectedBusiness={selectedBusiness} />} />
            <Route path="business/:id/check-write" element={<CheckWriter selectedBusiness={selectedBusiness} />} />
            <Route path="business/:id/cash-recon" element={<BusinessCashInPage selectedBusiness={selectedBusiness} />} />
            <Route path="business/:id/payroll-entry" element={<StaffPayrollInputsPage selectedBusiness={selectedBusiness} />} />
            {/* Add more routes if you expose others to business users */}
            <Route path="business/:id/invoice" element={<div>Invoice (BU)</div>} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default BusinessDashboard;




// import React, { useEffect, useRef, useState } from "react";
// import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
// import api from "../services/api";

// // Reuse your existing pages where possible:
// import BusinessUserNav from "./BusinessUserNav";
// import BusinessPage from "./BusinessPage";
// import EmployeesPage from "./EmployeesPage";
// import ViewPayrollPage from "./ViewPayroll";
// import CheckWriter from "./CheckWriter";
// import AccountingPage from "./AccountingPage";
// import BusinessUserProfilePage from "./BusinessUserProfilePage";

// // Optional: If you have distinct BU-specific variants, import those instead.
// // import BUEmployeesPage from "./BUEmployeesPage"; etc.

// //import "./BusinessDashboard.css";

// const BusinessDashboard = () => {
//   const [businesses, setBusinesses] = useState([]);
//   const [selectedBusiness, setSelectedBusiness] = useState(null);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const hamburgerRef = useRef(null);

//   const navigate = useNavigate();
//   const location = useLocation();

//   // Fetch businesses linked to the authenticated **business user**
//   // Backend should protect this with authenticateBusinessToken
//   const fetchBusinesses = async () => {
//     try {
//       const { data } = await api.get("/bu/businesses"); // <-- you’ll add this endpoint server-side
//       setBusinesses(data || []);
//       if (data && data.length > 0) setSelectedBusiness(data[0]);
//     } catch (e) {
//       alert("Failed to fetch businesses for business user.");
//     }
//   };

//   useEffect(() => { fetchBusinesses(); }, []);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Sync selected business with URL if present
//   useEffect(() => {
//     const match = location.pathname.match(/\/bu\/business\/(\d+)/);
//     if (match && businesses.length) {
//       const id = Number(match[1]);
//       const found = businesses.find((b) => b.id === id);
//       if (found && (!selectedBusiness || selectedBusiness.id !== found.id)) {
//         setSelectedBusiness(found);
//       }
//     }
//   }, [location.pathname, businesses, selectedBusiness]);

//   const handleBusinessChange = (e) => {
//     const id = Number(e.target.value);
//     const found = businesses.find((b) => b.id === id);
//     setSelectedBusiness(found || null);
//     if (found) navigate(`/bu/business/${found.id}`);
//   };

//   const handleLogout = async () => {
//     try {
//       await api.post("/business-logout"); // uses refreshTokenBu cookie
//       localStorage.removeItem("accessToken");
//       sessionStorage.removeItem("accessToken");
//       delete api.defaults.headers.common["Authorization"];
//       navigate("/home");
//       window.location.reload();
//     } catch (err) {
//       console.error("Logout failed:", err);
//     }
//   };

//   return (
//     <div className="bu-page">
//       <header className="bu-header">
//         {isMobile && (
//           <img src="/logo512.png" alt="Payweek Logo" className="dashboard-logo" />
//         )}

//         <div className="bu-business-selector">
//           <select
//             className="bu-business-select"
//             onChange={handleBusinessChange}
//             value={selectedBusiness?.id ?? "default"}
//           >
//             <option value="default" disabled>
//               Select a Business
//             </option>
//             {businesses.map((b) => (
//               <option key={b.id} value={b.id}>{b.name}</option>
//             ))}
//           </select>
//         </div>

//         <button
//           ref={hamburgerRef}
//           className="bu-hamburger"
//           onClick={() => setIsMobileMenuOpen((s) => !s)}
//         >
//           ☰
//         </button>

//         <button className="bu-logout" onClick={handleLogout}>
//           Logout
//         </button>
//       </header>

//       {!isMobile && <BusinessUserNav selectedBusiness={selectedBusiness} />}

//       {/* If you want a simple mobile overlay menu, you can add a small component similar to your owner MobileMenu */}

//       <div className="bu-body">
//         <main className="bu-content">
//           <Routes>
//             {/* default redirect */}
//             <Route path="/" element={<Navigate to="business/user/profile" />} />

//             {/* Profile/Settings (business user) */}
//             <Route path="business/user/profile" element={<BusinessUserProfilePage />} />

//             {/* Business-scoped routes */}
//             <Route path="business/:id" element={<BusinessPage selectedBusiness={selectedBusiness} />} />
//             <Route path="business/:id/employees" element={<EmployeesPage selectedBusiness={selectedBusiness} />} />
//             <Route path="business/:id/viewpayroll" element={<ViewPayrollPage selectedBusiness={selectedBusiness} />} />
//             <Route path="business/:id/check-write" element={<CheckWriter selectedBusiness={selectedBusiness} />} />
//             <Route path="business/:id/accounting" element={<AccountingPage selectedBusiness={selectedBusiness} />} />
//             {/* Add more routes if you expose others to business users */}
//             <Route path="business/:id/invoice" element={<div>Invoice (BU)</div>} />
//           </Routes>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default BusinessDashboard;
